<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @click:outside="$emit('close')">
    <v-card>
      <v-row>
        <v-card-title class="ml-5">
            {{$t("invoicing.setInvoiceStatesDialog.title")}}
        </v-card-title>
       </v-row>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-select
                v-model="newSalesInvoiceState"
                :items="Object.values(salesInvoiceStates)"
                :label="$t('invoicing.setInvoiceStatesDialog.salesInvoiceState')">
                <template slot="selection" slot-scope="data">
                  {{ $t(salesInvoiceStatusToTranslationKey(data.item)) }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ $t(salesInvoiceStatusToTranslationKey(data.item)) }}
                </template>
            </v-select>
        </v-col>
          <v-col cols="12" sm="6">
            <v-select
                v-model="newPurchaseInvoiceState"
                :items="Object.values(purchaseInvoiceStates)"
                :label="$t('invoicing.setInvoiceStatesDialog.purchaseInvoiceState')">
                <template slot="selection" slot-scope="data">
                  {{ $t(purchaseInvoiceStatusToTranslationKey(data.item)) }}
                </template>
                <template slot="item" slot-scope="data">
                  {{ $t(purchaseInvoiceStatusToTranslationKey(data.item)) }}
                </template>
            </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
           {{$t("invoicing.setInvoiceStatesDialog.warningMessage")}}
        </v-col>

      </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click.native="setStates"
          :loading="isChangingStates"
          color="primary"
        >
          {{ $t("common.save") }}
        </v-btn>
        <v-btn @click.native="$emit('close')">{{ $t("common.cancel") }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { TransportEventInvoicingMixin } from "@/models/TransportEventInvoicingStates";
export default {
    props: {
        isOpen: Boolean,
        transportEvent: Object
    },
    mixins: [ TransportEventInvoicingMixin ],
    data() {
        return {
            newSalesInvoiceState: 0,
            newPurchaseInvoiceState: 0,
            isChangingStates: false
        };
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                this.newSalesInvoiceState = this.transportEvent.salesInvoiceStatus;
                this.newPurchaseInvoiceState = this.transportEvent.purchaseInvoiceStatus;
            }
        }
    },
    methods: {
        setStates() {
            this.isChangingStates = true;
            this.$store.dispatch("transportEventTable/updateTransportEventStatuses", {
                id: this.transportEvent.id,
                statuses: {
                    salesInvoiceState: this.newSalesInvoiceState,
                    purchaseInvoiceState: this.newPurchaseInvoiceState
                }
            })
                .then(() => {
                    this.transportEvent.salesInvoiceStatus = this.newSalesInvoiceState;
                    this.transportEvent.purchaseInvoiceStatus = this.newPurchaseInvoiceState;
                })
                .finally(() => {
                    this.isChangingStates = false;
                    this.$emit("close");
                });
        }
    }
};
</script>

<style>
</style>
